import ImportPanel from './import-panel';
import { mixin as pluginMinx } from '@/plugin/index.min.js';
import CommonUploadPlugin from './plugins/CommonUploadPlugin';
import CommonImportPlugin from './plugins/CommonImportPlugin';
import EmapPlugin from './plugins/emap-plugin';
export default {
  name: 'DataImport',
  components: {
    ImportPanel
  },
  mixins: [pluginMinx],
  CommonUploadPlugin,
  CommonImportPlugin,
  EmapPlugin,
  props: {
    /**
     * 弹出框标题
     */
    title: {
      type: String,
      default: '导入数据'
    },

    /**
     * 默认的按钮文字，若用 slot 覆盖默认按钮此选项无效
     */
    text: {
      type: String,
      default: '导入'
    },

    /**
     * 上传文件是否需要二次确认
     */
    needConfirm: {
      type: Boolean,
      default: true
    },

    /**
     * 模板下载地址，若为动态地址，可通过插件监听 download-template 事件实现
     */
    templateLink: String,

    /**
     * 文件上传时文件参数的名称
     */
    uploadName: {
      type: String,
      default: 'file'
    },

    /**
     * 支持上传的文件类型
     */
    accept: {
      type: String,
      default: '.xlsx,.xlsm,.xltx,.xltm,.xlsb,.xlam,.xls'
    }
  },
  data: () => ({
    dialogVisible: false
  }),
  methods: {
    handleSuccess() {
      /**
       * 导入成功触发此事件
       */
      this.$emit('success');
    },

    handleClose() {
      this.dialogVisible = false;
      /**
       * 关闭弹窗触发此事件
       */

      this.$emit('close');
    },

    showDlg() {
      this.dialogVisible = true;
      /**
       * 打开弹窗触发此事件
       */

      this.$emit('open');
    }

  }
};